import script from "./ToastManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastManager.vue?vue&type=script&setup=true&lang=js"

import "./ToastManager.vue?vue&type=style&index=0&id=2c4b0319&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c4b0319"]])

export default __exports__